export const useFocusRing = () => {
  return {
    focusProps: {},
    isFocusVisible: false,
  };
};
